import { useCallback, useSyncExternalStore } from 'react'

/** Whether a CSS media query matches right now, e.g. `useMediaQuery('(max-width: 39.99rem)')`; follows resizes and rotation. */
export function useMediaQuery(query: string): boolean {
  const subscribe = useCallback(
    (onChange: () => void) => {
      const list = window.matchMedia(query)
      list.addEventListener('change', onChange)
      return () => list.removeEventListener('change', onChange)
    },
    [query],
  )
  return useSyncExternalStore(subscribe, () => window.matchMedia(query).matches)
}
